import React, { useEffect, useState } from 'react';
import './App.css';
import AllergyList from './components/AllergyList';
import type { SDK } from "vim-os-js-browser/api/vim-os-sdk-api";
import { loadSdk } from "vim-os-js-browser";
import { VimOSContext } from './context/vimOSContext';


const App: React.FC = () => {
  const [vimOS, setVimOS] = useState<SDK | undefined>(undefined);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const sdk = await loadSdk();
        setVimOS(sdk);
        sdk.hub.setActivationStatus('ENABLED');
        console.log('VimOS SDK loaded successfully');
      } catch (err: any) {
        console.error('Failed to load VIM OS SDK:', err);
        setError(err.message || 'Failed to load VIM OS SDK');
        
        // Allow running without SDK for development/testing
        console.warn('Running in standalone mode without VIM OS SDK');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column',
        gap: '1rem'
      }}>
        <div>Loading VIM SDK...</div>
      </div>
    );
  }

  if (error && !vimOS) {
    console.warn('Running without VIM OS context. Patient data will not be available.');
  }


  return (
    <div className="app">
      <header className="app-header">
        <h1>External Allergy Detection</h1>
        <p className="subtitle">Review and approve detected allergies for EHR integration</p>
      </header>
      <main className="app-main">
      <VimOSContext.Provider value={vimOS}>
         <AllergyList />
      </VimOSContext.Provider>
      </main>
    </div>
  );
};

export default App;
